





























































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { authorizationService } from "@/shared/services/AuthorizationService";
import { JwtService } from "@/shared/services/JwtService";
import { RouterNames } from "@/router/routernames";

@Component({
  components: {},
})
export default class UserProfile extends Vue {
  public menu: boolean = false;

  public get userName() {
    return authorizationService.userName();
  }

  public get userEmail(): string {
    try {
      const decoded = JwtService.jwtDecode();
      return decoded.email || decoded.unique_name || "";
    } catch {
      return "";
    }
  }

  public get userInitial(): string {
    const name = this.userName;
    return name && name.length > 0 ? name.charAt(0).toUpperCase() : "U";
  }

  public goPerfil() {
    this.$router.push({ name: RouterNames.mi_perfil });
    this.menu = false;
  }

  public goEditarPerfil() {
    this.$router.push({ name: RouterNames.mi_perfil });
    this.menu = false;
  }

  public logout() {
    authorizationService.logout();
    this.$router.push("/login");
  }
}
